import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: 320px;
  padding-bottom: calc(22px - 0.5rem);
  border-bottom: 1px solid ${({ theme }) => theme.mocaLtGrey};
`
